import React from 'react';
import PropTypes from 'prop-types';
import { Atoms, Charts } from 'components';
import { getMsInfo } from 'api/fetch_data';

class IvalMsInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            plotData: []
        };
        this.header = [
            { key: 'accession', content: 'Accession' },
            { key: 'file_name', content: 'File' },
            { key: 'peptide', content: 'Peptide' },
            { key: 'start', content: 'Start' },
            { key: 'end', content: 'End' },
            { key: 'PSM', content: 'PSM' }
        ];
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        this.__ignoreLastFetch = true;
    }

    fetchData = () => {
        const { genomeAbbr, id, recordType } = this.props;
        getMsInfo(genomeAbbr, id, recordType).then(data => {
            if (!this.__ignoreLastFetch && data) {
                const dataSource = data.map(item => ({ ...item }));
                const plotData = data.map(item => ({
                    group: item['file_name'],
                    start: item['start'],
                    end: item['end'],
                    strand: item['strand'],
                    name: item['peptide'],
                    blocks: [[item['start'], item['end']]],
                }));
                this.setState({ dataSource, plotData });
            }
        });
    };

    render() {
        const { dataSource, plotData } = this.state;
        const { ival, recordType } = this.props;

        if (dataSource.length === 0) {
            return null;
        }

        const edix = {
            'Trans': ival.exon_len,
            'Prot': ival.aa_num
        };
        return (
            <Atoms.InfoGroup title="Mass spectra evidence">
                <Charts.GeneStructure
                    bpStart={0}
                    bpEnd={edix[recordType]}
                    heightPerDataGroup={20}
                    width={1000}
                    padding={[10, 50, 30, 300]}
                    dataSource={plotData}
                />
                <Atoms.CustomTable
                    columns={this.header}
                    dataSource={dataSource}
                />
            </Atoms.InfoGroup>
        );
    }
}

IvalMsInfo.propTypes = {
    ival: PropTypes.object,
    genomeAbbr: PropTypes.string,
    speciesAbbr: PropTypes.string,
    id: PropTypes.string,
    recordType: PropTypes.string
};

export default IvalMsInfo;

